import AxiosInstance from "./api";

export const BinCardService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/bin-cards/paginate", {
      params: query,
    });
  },

  getById: async (id) => {
    return await AxiosInstance.get("/private/bin-cards/" + id);
  },

  create: async (payload) => {
    return await AxiosInstance.post("/private/bin-cards", payload);
  },

  update: async (id, payload) => {
    return await AxiosInstance.patch("/private/bin-cards/" + id, payload);
  },

  delete: async (id) => {
    return await AxiosInstance.delete("/private/bin-cards/" + id);
  },
};
